module.exports = __webpack_public_path__ + "static/media/marisa6.d6f490a3.mp3";